import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentDelete = {
    path: "/consent/:id",
    method: RouteHttpVerb.DELETE
};
